const product = {
  product: "产品", // translated
  products: "产品", // translated
  information: "信息", // translated
  additionalInformation: "附加信息", // translated
  contactUs: "联系我们", // translated
  contactUsText: "想要定制您的旅行或有任何其他问题吗？", // translated
  dropUsAnEmail: "给我们发电子邮件", // translated
  viewLess: "查看较少", // translated
  viewMore: "查看更多", // translated
  less: "较少的", // translated
  more: "更多的", // translated
  highlights: "强调", // translated
  inclusions: "内含物", // translated
  exclusions: "排除情况", // translated
  pleaseWait: "请稍等...", // translated
  tourType: "旅游类型", // translated
  search: "搜索", // translated
  available: "可用的", // translated
  availableTours: "可用的旅游", // translated
  sortBy: "排序方式", // translated
  priceLowToHigh: "价格：从低到高", // translated
  priceHighToLow: "价格：从高到低", // translated
  mostPopular: "最受欢迎", // translated
  roomOnly: "仅限房间", // translated
  bedAndBreakfast: "床和早餐", // translated
  halfBoard: "半食宿", // translated
  fullBoard: "全膳", // translated
  allInclusive: "全包", // translated
  viewDetails: "查看详情", // translated
  close: "关闭", // translated
  at: "在", // translated
  person: "人", // translated
  cancellationPolicy: "取消政策", // translated
  cancellationIs: "取消是", // translated
  to: "到", // translated
  bookingRemarks: "预订备注", // translated
  totalPrice: "总价", // translated
  back: "返回", // translated
  bookNow: "现在预订", // translated
  minutes: "分钟", // translated
  visitDuration: "参观时间", // translated
  itinerary: "行程", // translated
  airportToHotel: "机场到酒店", // translated
  hotelToAirport: "酒店到机场", // translated
  details: "细节", // translated
  servicesDetails: "服务详情", // translated
  services: "服务", // translated
  day: "天", // translated
  next: "下一个", // translated
  nextStep: "下一步", // translated
  skip: "跳过", // translated
  remarks: "评论", // translated
  optional: "选修的", // translated
  guests: "客人", // translated
  payment: "支付", // translated
  pickup: "捡起", // translated
  featuredPackage: "特色套餐", // translated
  flights: "航班", // translated
  accommodation: "住宿", // translated
  transfers: "接送服务", // translated
  tours: "旅游", // translated
  experiences: "经验", // translated
  featuredTour: "特色旅游", // translated
  From: "从", // translated
  Accommodation: "住宿", // translated
  approxDuration: "大约。期间", // translated
  travellerInformation: "旅客信息", // translated
  bookingOverview: "预订概览", // translated
  checkout: "查看", // translated
  paymentFailed: "支付失败", // translated
  paymentSuccess: "支付成功", // translated
  night: "夜晚", // translated
  nights: "夜晚", // translated
  viewEscapes: "查看逃脱", // translated
  viewExperience: "查看体验", // translated
  escapeType: "逃生类型", // translated
  adultsOnly: "只有成年人", // translated
  totalDuration: "总持续时间", // translated
  options: "选项", // translated
  departingAirport: "出发机场", // translated
  childrenAreNotAllowedInThisTour: "儿童不允许参加此行程", // translated
};

export default product;
